import { getCookie } from './cookies';

export const NEW_COMMENTS_DESIGN_COOKIE = 'newCommentsDesign';

export const SHOW_REACTIONS_COOKIE = 'showReactions';

export const isNewCommentsDesign = (): boolean => Boolean(getCookie(NEW_COMMENTS_DESIGN_COOKIE));

// Same cookie as the gallery, which renders no reaction UI without it.
export const isReactionsEnabled = (): boolean => Boolean(getCookie(SHOW_REACTIONS_COOKIE));
